import { render, staticRenderFns } from "./ProfileMessages.vue?vue&type=template&id=e06eaa96&"
import script from "./ProfileMessages.vue?vue&type=script&lang=js&"
export * from "./ProfileMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports